var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgExpand = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0.00 0.00 256.00 256.00",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    id: "arrow_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.27,53.18 L49.55,53.18",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 23.2,
    strokeOpacity: 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.27,213.18 L49.55,213.18",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 23.2,
    strokeOpacity: 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.65,80.80 L154.38,101.53",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 13,
    strokeOpacity: 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.68,101.77 L133.65,80.80 L133.65,188.29 L112.73,165.91",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 13,
    strokeOpacity: 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.65,188.29 L154.55,165.45",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 13,
    strokeOpacity: 1,
    strokeLinejoin: "round"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExpand, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/expand.f4b42303.svg";
export { ForwardRef as ReactComponent };